/**
 * SCS_MENU_03 — Mobile quadrant navigation Elevate A/B test
 * Boots only when window.scs_menu_03_new === true and viewport ≤ 990px.
 */
(function () {
  'use strict';

  var TEST_NAME = 'SCS_MENU_03';
  var MQ = '(max-width: 990px)';
  var API_BASE = 'https://scsbiz3.wearevisum.com/api/v1/years';
  var CONTAINER_SEL = '#Details-menu-drawer-container #menu-drawer .menu-drawer__navigation-container';
  var SEAT_COVER_PATH = '/pages/love-your-ride-deal';

  // var FONT_URL = 'https://fonts.googleapis.com/css2?family=Inter:wght@700&family=Oswald:wght@700&family=Roboto:wght@400;500;700&display=swap';

  var QUADS = [
    {
      label: 'SEAT COVERS',
      href: SEAT_COVER_PATH,
      image:
        'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/Seat_Cover_Menu.png?v=1787559458'
    },
    {
      label: 'STEERING WHEEL COVERS',
      href: '/products/steering-wheel-cover',
      image:
        'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/STEERING_WHEEL_COVERS_MENU.jpg?v=1787559457'
    },
    {
      label: 'PET SEAT COVERS',
      href: '/products/petsuite-hard-bottom-dog-seat-protector-no-fur',
      image:
        'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/PET_SEAT_COVERS_MENU.png?v=1787559459'
    },
    {
      label: 'ACCESSORIES',
      href: '/collections/all',
      image:
        'https://cdn.shopify.com/s/files/1/0732/5909/0212/files/ACCESSORIES_MENU.png?v=1787559459'
    }
  ];

  var MODEL_SORT_ORDER = {
    Ford: { 'F-150': 9010, 'F-250': 9009, 'F-350': 9008, Ranger: 9007 },
    Ram: { '1500': 8510, '2500': 8509, '3500': 8508 },
    Chevrolet: {
      'Silverado 1500': 8010,
      'Silverado 2500 HD': 8009,
      'Silverado 3500 HD': 8008,
      Colorado: 8007
    },
    GMC: {
      'Sierra 1500': 7510,
      'Sierra 2500 HD': 7509,
      'Sierra 3500 HD': 7508,
      Canyon: 7507
    },
    Dodge: { 'Ram 1500': 7010, 'Ram 2500': 7009, 'Ram 3500': 7008 },
    Toyota: { Tundra: 6510, Tacoma: 6509, '4Runner': 6508 }
  };

  var state = {
    booted: false,
    originalHTML: null,
    container: null,
    yearSel: null,
    makeSel: null,
    modelSel: null,
    cta: null
  };

  function isFlagOn() {
    return window.scs_menu_03_new === true;
  }

  function isMobile() {
    return window.matchMedia(MQ).matches;
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function runAt(selector, callback) {
    function tryFind() {
      var el = document.querySelector(selector);
      if (el) {
        callback(el);
        return true;
      }
      return false;
    }
    if (tryFind()) return;
    var observer = new MutationObserver(function () {
      if (tryFind()) observer.disconnect();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  // function injectFont() {
  //   if (document.querySelector('link[data-scs-menu-03-font]')) return;
  //   var link = document.createElement('link');
  //   link.rel = 'stylesheet';
  //   link.href = FONT_URL;
  //   link.setAttribute('data-scs-menu-03-font', 'true');
  //   document.head.appendChild(link);
  // }

  function salesQuery() {
    return window.scs_use_optgroup ? 'with_sales=yes' : '';
  }

  function apiUrl(params) {
    var qs = [];
    var sales = salesQuery();
    if (sales) qs.push(sales);
    if (params) {
      Object.keys(params).forEach(function (k) {
        if (params[k] != null && params[k] !== '') {
          qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(params[k]));
        }
      });
    }
    return API_BASE + (qs.length ? '?' + qs.join('&') : '');
  }

  function fetchJson(url) {
    return fetch(url, {
      mode: 'cors',
      headers: { 'Access-Control-Allow-Origin': '*' }
    }).then(function (r) {
      return r.json();
    });
  }

  function makeOpt(val, selected) {
    var opt = document.createElement('option');
    opt.value = val;
    opt.textContent = val;
    if (selected) opt.selected = true;
    return opt;
  }

  function makeGroup(label) {
    var g = document.createElement('optgroup');
    g.label = label;
    return g;
  }

  function resetSel(sel, placeholder) {
    while (sel.firstChild) sel.removeChild(sel.firstChild);
    var def = document.createElement('option');
    def.value = '';
    def.textContent = placeholder;
    sel.appendChild(def);
  }

  function appendMakes(sel, makes) {
    var list = (makes || []).filter(function (m) {
      return String(m).trim();
    });
    if (window.scs_use_optgroup) {
      var top = makeGroup('Top Sellers');
      var rest = makeGroup('All Others');
      list.forEach(function (m, i) {
        (i < 6 ? top : rest).appendChild(makeOpt(m, false));
      });
      sel.appendChild(top);
      sel.appendChild(rest);
    } else {
      list.forEach(function (m) {
        sel.appendChild(makeOpt(m, false));
      });
    }
  }

  function sortModelKeys(models, makeName) {
    var keys = Object.keys(models || {}).filter(function (m) {
      return String(m).trim();
    });
    var orderMap = MODEL_SORT_ORDER[makeName] || null;
    if (!orderMap) {
      return keys.sort();
    }
    return keys.sort(function (a, b) {
      var ao = orderMap[a];
      var bo = orderMap[b];
      if (ao != null && bo != null) return bo - ao;
      if (ao != null) return -1;
      if (bo != null) return 1;
      return a.localeCompare(b);
    });
  }

  function appendModels(sel, models, makeName) {
    var keys = sortModelKeys(models, makeName);
    if (window.scs_use_optgroup) {
      var orderMap = MODEL_SORT_ORDER[makeName] || {};
      var hasOrder = Object.keys(orderMap).length > 0;
      var top = makeGroup('Top Sellers');
      var rest = makeGroup('All Others');
      keys.forEach(function (m, i) {
        var inTop = hasOrder ? orderMap[m] != null : i < 6;
        (inTop ? top : rest).appendChild(makeOpt(m, false));
      });
      sel.appendChild(top);
      sel.appendChild(rest);
    } else {
      keys.forEach(function (m) {
        sel.appendChild(makeOpt(m, false));
      });
    }
  }

  function buildHTML() {
    var quads = QUADS.map(function (q) {
      return (
        '<a class="' +
        TEST_NAME +
        '__quad" href="' +
        q.href +
        '">' +
        '<img class="' +
        TEST_NAME +
        '__quad-img" src="' +
        q.image +
        '" alt="" loading="lazy" width="170" height="170">' +
        '<span class="' +
        TEST_NAME +
        '__quad-label">' +
        q.label +
        '</span>' +
        '</a>'
      );
    }).join('');

    return (
      '<nav class="' +
      TEST_NAME +
      '__nav" aria-label="Mobile navigation">' +
      '<div class="' +
      TEST_NAME +
      '__grid">' +
      quads +
      '</div>' +
      '<div class="' +
      TEST_NAME +
      '__setup">' +
      '<div class="' +
      TEST_NAME +
      '__vehicle">' +
      '<div class="' +
      TEST_NAME +
      '__vehicle-header">' +
      '<span class="' +
      TEST_NAME +
      '__step" aria-hidden="true">1</span>' +
      '<p class="' +
      TEST_NAME +
      '__vehicle-title">Vehicle Details</p>' +
      '</div>' +
      '<div class="' +
      TEST_NAME +
      '__fields-row">' +
      '<span class="' +
      TEST_NAME +
      '__rail" aria-hidden="true"></span>' +
      '<div class="' +
      TEST_NAME +
      '__fields">' +
      '<div class="' +
      TEST_NAME +
      '__field">' +
      '<select class="' +
      TEST_NAME +
      '__select" id="SCS_MENU_03_year" aria-label="Year" disabled>' +
      '<option value="">Year</option>' +
      '</select>' +
      '</div>' +
      '<div class="' +
      TEST_NAME +
      '__field">' +
      '<select class="' +
      TEST_NAME +
      '__select" id="SCS_MENU_03_make" aria-label="Make" disabled>' +
      '<option value="">Make</option>' +
      '</select>' +
      '</div>' +
      '<div class="' +
      TEST_NAME +
      '__field">' +
      '<select class="' +
      TEST_NAME +
      '__select" id="SCS_MENU_03_model" aria-label="Model" disabled>' +
      '<option value="">Model</option>' +
      '</select>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '</div>' +
      '<div class="' +
      TEST_NAME +
      '__cta-wrap">' +
      '<button type="button" class="' +
      TEST_NAME +
      '__cta is-disabled" id="SCS_MENU_03_cta" disabled>' +
      '<span class="' +
      TEST_NAME +
      '__cta-text">Select Your Year</span>' +
      '<span class="' +
      TEST_NAME +
      '__cta-arrow" aria-hidden="true"></span>' +
      '</button>' +
      '</div>' +
      '</div>' +
      '<div class="' +
      TEST_NAME +
      '__links">' +
      '<a class="' +
      TEST_NAME +
      '__link-card" href="/pages/frequently-asked-questions">' +
      '<span class="' +
      TEST_NAME +
      '__link-card-label">FAQ</span>' +
      '<span class="' +
      TEST_NAME +
      '__link-card-arrow" aria-hidden="true"></span>' +
      '</a>' +
      '<a class="' +
      TEST_NAME +
      '__link-card" href="/pages/our-story">' +
      '<span class="' +
      TEST_NAME +
      '__link-card-label">Our Story</span>' +
      '<span class="' +
      TEST_NAME +
      '__link-card-arrow" aria-hidden="true"></span>' +
      '</a>' +
      '<a class="' +
      TEST_NAME +
      '__account" href="/account">' +
      '<span class="' +
      TEST_NAME +
      '__account-icon" aria-hidden="true"></span>' +
      '<span class="' +
      TEST_NAME +
      '__account-label">My Account</span>' +
      '</a>' +
      '</div>' +
      '</nav>'
    );
  }

  function setPulse(el) {
    [state.yearSel, state.makeSel, state.modelSel].forEach(function (s) {
      if (!s) return;
      s.classList.remove('is-active');
      s.classList.remove(TEST_NAME + '__pulse');
    });
    if (el) {
      el.classList.add('is-active');
      el.classList.add(TEST_NAME + '__pulse');
    }
  }

  function updateCta() {
    var year = state.yearSel.value;
    var make = state.makeSel.value;
    var model = state.modelSel.value;
    var textEl = state.cta.querySelector('.' + TEST_NAME + '__cta-text');
    var label = 'Select Your Year';
    var ready = false;

    if (!year) {
      label = 'Select Your Year';
      setPulse(state.yearSel);
    } else if (!make) {
      label = 'Select Your Make';
      setPulse(state.makeSel);
    } else if (!model) {
      label = 'Select Your Model';
      setPulse(state.modelSel);
    } else {
      label = 'FIND MY FIT';
      ready = true;
      setPulse(null);
    }

    if (textEl) textEl.textContent = label;

    if (ready) {
      state.cta.disabled = false;
      state.cta.classList.remove('is-disabled');
    } else {
      state.cta.disabled = true;
      state.cta.classList.add('is-disabled');
    }
  }

  function loadYears() {
    resetSel(state.yearSel, 'Year');
    resetSel(state.makeSel, 'Make');
    resetSel(state.modelSel, 'Model');
    state.makeSel.disabled = true;
    state.modelSel.disabled = true;
    state.yearSel.disabled = true;

    fetchJson(apiUrl())
      .then(function (data) {
        var years = Array.isArray(data) ? data : data.years || [];
        years.forEach(function (yr) {
          state.yearSel.appendChild(makeOpt(String(yr), false));
        });
        state.yearSel.disabled = false;
        updateCta();
      })
      .catch(function () {
        state.yearSel.disabled = false;
        updateCta();
      });
  }

  function onYearChange() {
    var year = state.yearSel.value;
    resetSel(state.makeSel, 'Make');
    resetSel(state.modelSel, 'Model');
    state.makeSel.disabled = true;
    state.modelSel.disabled = true;
    updateCta();

    if (!year) return;

    fetchJson(apiUrl({ year: year }))
      .then(function (data) {
        appendMakes(state.makeSel, data.makes || []);
        state.makeSel.disabled = false;
        updateCta();
      })
      .catch(function () {
        updateCta();
      });
  }

  function onMakeChange() {
    var year = state.yearSel.value;
    var make = state.makeSel.value;
    resetSel(state.modelSel, 'Model');
    state.modelSel.disabled = true;
    updateCta();

    if (!year || !make) return;

    fetchJson(apiUrl({ year: year, make: make }))
      .then(function (data) {
        appendModels(state.modelSel, data.models || {}, make);
        state.modelSel.disabled = false;
        updateCta();
      })
      .catch(function () {
        updateCta();
      });
  }

  function onCtaClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();

    var year = state.yearSel.value;
    var make = state.makeSel.value;
    var model = state.modelSel.value;
    if (!year || !make || !model) return;

    // Keep the drawer open while we navigate (don't animate-close first).
    var details = document.querySelector('#Details-menu-drawer-container');
    if (details) {
      details.setAttribute('open', '');
      details.classList.add('menu-opening');
    }

    var url =
      SEAT_COVER_PATH +
      '?make=' +
      encodeURIComponent(make) +
      '&model=' +
      encodeURIComponent(model) +
      '&year=' +
      encodeURIComponent(year);
    window.location.assign(url);
  }

  function bindYmm() {
    state.yearSel = document.getElementById('SCS_MENU_03_year');
    state.makeSel = document.getElementById('SCS_MENU_03_make');
    state.modelSel = document.getElementById('SCS_MENU_03_model');
    state.cta = document.getElementById('SCS_MENU_03_cta');

    if (!state.yearSel || !state.makeSel || !state.modelSel || !state.cta) return;

    state.yearSel.addEventListener('change', onYearChange);
    state.makeSel.addEventListener('change', onMakeChange);
    state.modelSel.addEventListener('change', updateCta);
    state.cta.addEventListener('click', onCtaClick, true);

    loadYears();
  }

  function stripCompetingNodes(container) {
    var selectors = [
      '.ACC_SCS_Menu_02_menuBlocks_wrap',
      '.ACC_SCS_Menu_02_menu_item_card',
      '.SCS_menu_01__menu',
      '.SCS_menu_01__info-section',
      '.SCS_menu_01__item',
      '.menu-drawer__utility-links'
    ];
    selectors.forEach(function (sel) {
      container.querySelectorAll(sel).forEach(function (node) {
        node.remove();
      });
    });
    // Also remove siblings injected outside container but inside drawer
    var drawer = document.querySelector('#Details-menu-drawer-container #menu-drawer');
    if (!drawer) return;
    drawer.querySelectorAll('.SCS_menu_01__menu, .SCS_menu_01__info-section, .ACC_SCS_Menu_02_menuBlocks_wrap').forEach(function (node) {
      if (!container.contains(node) || !node.closest('.' + TEST_NAME + '__nav')) {
        node.remove();
      }
    });
  }

  function render(container) {
    if (!container) return;
    if (state.originalHTML === null) {
      state.originalHTML = container.innerHTML;
    }
    state.container = container;
    stripCompetingNodes(container);
    container.innerHTML = buildHTML();
    bindYmm();
  }

  function restore() {
    if (state.container && state.originalHTML !== null) {
      state.container.innerHTML = state.originalHTML;
    }
    document.body.classList.remove(TEST_NAME);
    state.booted = false;
    state.yearSel = null;
    state.makeSel = null;
    state.modelSel = null;
    state.cta = null;
  }

  function boot() {
    if (!isFlagOn() || !isMobile() || state.booted) return;
    state.booted = true;
    // injectFont();
    document.body.classList.add(TEST_NAME);
    runAt(CONTAINER_SEL, function (container) {
      if (!isFlagOn() || !isMobile()) {
        restore();
        return;
      }
      render(container);
      // Re-strip competing nodes that inject after us
      var retries = 0;
      var timer = setInterval(function () {
        retries += 1;
        if (state.container) stripCompetingNodes(state.container);
        if (retries >= 10) clearInterval(timer);
      }, 300);
    });
  }

  function handleViewportChange() {
    if (!isFlagOn()) return;
    if (isMobile()) {
      if (!state.booted) boot();
    } else if (state.booted) {
      restore();
    }
  }

  onReady(function () {
    if (!isFlagOn()) return;
    boot();
    if (window.matchMedia) {
      var mql = window.matchMedia(MQ);
      if (mql.addEventListener) {
        mql.addEventListener('change', handleViewportChange);
      } else if (mql.addListener) {
        mql.addListener(handleViewportChange);
      }
    }
  });
})();
